var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('img',{staticClass:"loading-img",attrs:{"src":require("../assets/image/icon_loading.png"),"alt":"加载中"}}),_c('span',[_vm._v("生成中")])])
}]

export { render, staticRenderFns }